export enum CheckboxStates {
	partial = 'partial',
	empty = 'empty',
	full = 'full',
}
